/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Open360EntitiesListItemsClassificationCategoryListItem {
    /**
     * 1 = Shop, 2 = ShoppingCentre, 3 = Restaurant, 4 = Attraction, 5 = Accommodation, 6 = Education, 7 = Exhibition, 8 = Exhibitor
     */
    Type?: Open360EntitiesListItemsClassificationCategoryListItem.TypeEnum;
    AdvertPrice?: number;
    ID?: number;
    ParentID?: number;
    Level?: number;
    Name?: string;
    FullName?: string;
    Subcategories?: Array<Open360EntitiesListItemsClassificationCategoryListItem>;
    logoPurple?: string;
    logoWhite?: string;
}
export namespace Open360EntitiesListItemsClassificationCategoryListItem {
    export type TypeEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
    export const TypeEnum = {
        NUMBER_1: 1 as TypeEnum,
        NUMBER_2: 2 as TypeEnum,
        NUMBER_3: 3 as TypeEnum,
        NUMBER_4: 4 as TypeEnum,
        NUMBER_5: 5 as TypeEnum,
        NUMBER_6: 6 as TypeEnum,
        NUMBER_7: 7 as TypeEnum,
        NUMBER_8: 8 as TypeEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360EntitiesListItemsClassificationCategoryListItem.ts